'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var templateFactory = function () {
    function templateFactory() {
        (0, _classCallCheck3.default)(this, templateFactory);

        this.templates = {};
    }

    (0, _createClass3.default)(templateFactory, [{
        key: 'registerTemplate',
        value: function registerTemplate(name, templateHandler, ingoreExists) {
            if (this.templates[name]) {
                if (ingoreExists) {
                    return;
                } else {
                    throw 'template existed. name: ' + name;
                }
            }
            this.templates[name] = templateHandler;
        }
    }, {
        key: 'registerTemplates',
        value: function registerTemplates(templates) {
            var _this = this;

            if (!templates || templates.length == 0) return;
            templates.forEach(function (t) {
                return _this.registerTemplate(t.name, t.templateHandler);
            });
        }
    }, {
        key: 'getTemplate',
        value: function getTemplate(name) {
            if (!name) throw 'template name can not null';
            var template = this.templates[name];
            return template;
        }
    }]);
    return templateFactory;
}();

var instance = new templateFactory();

exports.default = instance;
module.exports = exports['default'];